import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Spinner } from "reactstrap"
import { isLoadingNow, subscribe } from "utils/loaderBus"

export default function GlobalLoader() {
  const [loading, setLoading] = useState(isLoadingNow())
  const mode = useSelector(state => state.Layout.layoutMode)

  useEffect(() => subscribe(setLoading), [])

  if (!loading) return null

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          mode === "dark" ? "rgba(15, 23, 42, 0.65)" : "rgba(255, 255, 255, 0.65)",
      }}
    >
      <Spinner
        style={{
          width: "3rem",
          height: "3rem",
          color: mode === "dark" ? "#fff" : "#2990DF",
        }}
      />
    </div>
  )
}
